import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.resize = this.resize.bind(this)
    window.addEventListener("resize", this.resize)
    this.resize() // initial resize
  }

  disconnect() {
    window.removeEventListener("resize", this.resize)
  }

  resize() {
    const select = this.element.querySelector("select")
    if (select) {
      $(select).select2({ width: '100%' });
    }
  }
}
